import script from "./aboutus.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutus.vue?vue&type=script&setup=true&lang=js"

import "./aboutus.vue?vue&type=style&index=0&id=7179d7c7&lang=less"
import "./aboutus.vue?vue&type=style&index=1&id=7179d7c7&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/www.7pa.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7179d7c7"]])

export default __exports__